<template>
  <div>
    <template v-if="activities == null"></template>

    <template v-else>

      <!-- <Filters v-if="showFilters" :params="params"></Filters> -->

      <template v-if="activities.length == 0"></template>

      <template v-else>
        <ActivityListItem
          v-for="(activity, index) in activities"
          :activity="activity"
          :index="index"
          :key="activity.id">
        </ActivityListItem>
        
        <div class="my-6 flex justify-between">
          <div class="flex items-center">
            <v-pagination 
              v-if="numActivities > params.limit"
              v-model="currentPage"
              :page-count="Math.ceil(numActivities / params.limit)"
              :labels="customLabels" />
          </div>

          <div class="mr-4 text-gray-600">
            Found {{ numActivities }} {{ numActivities == 1 ? 'activity' : 'activities' }}
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import ActivityListItem from "./ActivityListItem"
  import { EventBus }     from '@/shared/event-bus'
  import Filters          from "./Filters"
  import vPagination      from 'vue-plain-pagination'

  export default {

    props : {
      showFilters : {
        type    : Boolean,
        required: false,
        default : true
      },

      limit : {
        type    : Number,
        required: false,
        default : 30
      },

      showPagination : {
        type    : Boolean,
        required: false,
        default : true
      },

      paddingTop : {
        type    : Number,
        required: false,
        default :135
      },

      showLoading : {
        type    : Boolean,
        required: false,
        default : true
      }
    },

    components : {
      ActivityListItem,
      Filters,
      vPagination
    },

    data () {
      return {
        activities       : null,
        numActivities    : null,
        
        currentPage : 1,
        customLabels: {
          first: false,
          prev: 'Previous',
          next: 'Next',
          last: false
        },
        
        selectedClient   : null,
        openClientOptions: false,
        
        params           : {}
      }
    },

    watch: {
      '$route' : {
        immediate: true,
        handler  : function(to, from) {
          if(Object.keys(to.params).length == 1) {
            this.resetParams()
          }

          else {
            this.setParams(to.params)
          }
          this.getActivities()
        }
      },

      'currentPage' : {
        handler(to, from) {
          EventBus.$emit('param-changed', {
            key  : 'offset',
            value: this.params.limit * (to-1)
          })
        }
      }
    },

    mounted() {
      EventBus.$on('param-changed', keyValue => {
        this.params[keyValue.key] = keyValue.value
        this.$router.push({
          name   : 'client-activity-search',
          params : this.params
        });
      });
    },

    methods: {

      setParams(params) {

        // this is when we landed on the page and then clicked on
        // any search params to start a search
        if(params && Object.keys(params).length > 0) {
          this.params = params
        }

        // this is when we land directly on a particular search params
        else if(Object.keys(this.$route.params).length > 0) {
          this.params = this.$route.params
        }
      },

      resetParams() {
        this.params = {
          clientId    : this.$route.params.clientId,
          activityType: "all",
          orderBy     : "updated_at",
          orderType   : "desc",
          limit       : 50,
          offset      : 0
        }
      },

      getActivities() {

        if(this.showLoading) {
          EventBus.$emit('set-content-loading', {
            display    : true,
            message    : 'Loading activities...',
            leftPadding: 0,
            center     : true
          })
        }

        this.apiGet(this.params, 'client/activities', (data) => {
          this.hideLoader()
          this.activities    = data.activities
          this.numActivities = data.total
        })
      },

      // whenever someone clicks on the table header, we will update the ordering
      // of the table
      // But what if we clicked on the same header that we are already ordering by?
      // in that case, we are simply swapping from either ascending to descending or
      // vice versa
      updateOrderBy(orderBy) {
        if(this.params.orderBy == orderBy) {
          this.params.orderBy = this.params.orderType == 'asc' ? 'desc' : 'asc'
        } else {
          this.params.orderBy = orderBy
        }

        this.getActivitiesAndUpdateRoute()
      },

      paginate: function(pageNum) {
        this.params.offset = this.params.limit * (pageNum-1)
        this.getActivitiesAndUpdateRoute()
      },

      // each time the search parameter changes
      // we need to update the params on the store
      // and also update the route to reflect the changes
      // so that whenever user refreshes the URL, they are
      // landed on the same page
      // This method is usually accessed from the client list page
      getActivitiesAndUpdateRoute() {
        
        // and let's refresh the route to reflect the new change
        this.$router.push({
          name   : 'client-activity-search',
          params : this.params
        });

        // let's re-fetch the clients
        this.getActivities()
      },
    }
  }
</script>